<div class="tag" [ngClass]="'tag-' + tag.color" [class.select]="selected" (click)="onToggleSelected(tag)">
  {{tag.label}}
</div>
